module.exports = __webpack_public_path__ + "assets/img/media-music-layer-50-6a827360.png";